/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from 'react-easy-emoji';

const illustration = {
  animated: false, // set to false to use static SVG
};

const greeting = {
  username: 'thesid01',
  title: "Hi, I am Sid",
  subTitle: emoji(
    'A passionate Software Developer 🚀 cum Competitive Programmer having an experience of building Web with JavaScript / Reactjs / Nodejs / Django and some other cool libraries and frameworks.'
  ),
  resumeLink:
    'https://drive.google.com/file/d/1wJuLfHaVvjPUjXs_stNWMQ9wU5bjK2xO/view?usp=sharing',
  displayGreeting: true, // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: 'https://github.com/thesid01',
  linkedin: 'https://www.linkedin.com/in/thesid01/',
  gmail: 'thesid01@gmail.com',
  gitlab: 'https://gitlab.com/thesid01',
  facebook: 'https://www.facebook.com/versidd',
  medium: 'https://medium.com/@sidkv.skv',
  instagram: 'https://www.instagram.com/sid_dharth_verma/',
  stackoverflow: 'https://stackoverflow.com/users/10304642/siddhartha-kumar-verma',
  // Instagram and Twitter are also supported in the links!
  display: true, // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: 'What I do',
  subTitle: 'A DEVELOPER WHO WANTS TO EXPLORE EVERY NEW TECH OUT THERE',
  skills: [
    // emoji(
    //   '⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications'
    // ),
    // emoji('⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks'),
    // emoji(
    //   '⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean'
    // ),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: 'html-5',
      fontAwesomeClassname: 'fab fa-html5',
    },
    {
      skillName: 'css3',
      fontAwesomeClassname: 'fab fa-css3-alt',
    },
    {
      skillName: 'JavaScript',
      fontAwesomeClassname: 'fab fa-js',
    },
    {
      skillName: 'reactjs',
      fontAwesomeClassname: 'fab fa-react',
    },
    {
      skillName: 'nodejs',
      fontAwesomeClassname: 'fab fa-node',
    },
    {
      skillName: 'Django',
      fontAwesomeClassname: 'fab fa-django',
    },
    {
      skillName: 'npm',
      fontAwesomeClassname: 'fab fa-npm',
    },
    {
      skillName: 'sql-database',
      fontAwesomeClassname: 'fas fa-database',
    },
    {
      skillName: 'aws',
      fontAwesomeClassname: 'fab fa-aws',
    },
    {
      skillName: 'firebase',
      fontAwesomeClassname: 'fas fa-fire',
    },
    {
      skillName: 'python',
      fontAwesomeClassname: 'fab fa-python',
    },
    {
      skillName: 'java',
      fontAwesomeClassname: 'fab fa-java',
    },
    {
      skillName: 'docker',
      fontAwesomeClassname: 'fab fa-docker',
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: 'Indian Institute of Information Technology, Jabalpur',
      logo: require('./assets/images/iiitdmj.png'),
      subHeader: 'Bachelors of Technology in Computer Science',
      duration: 'August 2017 - April 2021',
      desc: 'Member of BitByte Club (Programming Club) and NSS (National Service Scheme).',
      descBullets: [
        'CPI: 8.9',
      //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
      ],
    },
  ],
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: 'Programming',
      progressPercentage: '85%',
    },
    {
      Stack: 'Backend Development', //Insert stack or technology you have experience in
      progressPercentage: '70%', //Insert relative proficiency in percentage
    },
  ],
  displayCodersrank: false, // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: 'Software Engineer Intern',
      company: 'Amazon',
      companylogo: require('./assets/images/amazonLogo.png'),
      date: 'Jan 2021 - Present',
      desc:
      'Working with Core Trans Technology Team to improve the logistic and shipping services.',
      descBullets: [
        'Working on migration of a existing service to another.'
      ]
    },
    {
      role: 'Software Developer Engineer Intern',
      company: 'WikiPro',
      companylogo: require('./assets/images/wikiProLogo.png'),
      date: 'July 2020 – November 2020',
      desc:
        'Collaborated with the Web Team and implemented new functionalities for the platform using Django and ReactJs.',
      descBullets: [
        'Added an features in chat groups, leading to enhancement of user experience.',
        'Integrated stripe payment to the website for billing of the product.',
        'Created a simple file uploading feature for easy file sharing between client and company.',
        'Worked on celery to make recurring tasks.'
      ]
    },
    {
      role: 'Software Engineer Intern',
      company: 'IBM',
      companylogo: require('./assets/images/ibmLogo.png'),
      date: 'May 2019 – July 2019',
      desc:
        'Consistent and vendor agnostic Orchestration Automation.',
      descBullets: [
        'The results of this project can have a significant shift in the Orchestration Strategy for IBM Cloud Deployment Services.',
        'This can be the consistent strategy for Orchestration for all Orchestrator Platform such as vRA, CAM, ICP and Orchestration Solution such as PPO, DHS Automation'
      ],
    },
  ],
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: '1cc02944e29dccf867ea1040b00311b998553507',
  githubUserName: 'thesid01', // Change to your github username to view your profile in Contact Section.
  showGithubProfile: 'true', // Set true or false to show Contact profile using Github, defaults to true
  display: true, // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  // title: 'Projects',
  // subtitle: 'SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH',
  // projects: [
  //   {
  //     image: require('./assets/images/saayaHealthLogo.webp'),
  //     link: 'http://saayahealth.com/',
  //   },
  //   {
  //     image: require('./assets/images/nextuLogo.webp'),
  //     link: 'http://nextu.se/',
  //   },
  // ],
  // display: true, // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji('Achievements and Accomplishment 🏆 '),
  subtitle:
    'Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !',

  achievementsCards: [
    {
      title: 'ACM ICPC Regionalist (Kharagpur)',
      subtitle:
        'Secured 68th rank among 98 participants in Kolkata regionals (onsite).',
      image: require('./assets/images/icpcLogo.png'),
      footerLink: [
        {
          name: 'ICPC ID',
          url:
            'https://icpc.global/ICPCID/4FNBY1KPT7Y8',
        },
      ],
    },
    {
      title: 'Smart India Hackathon Finalist',
      subtitle:
        'Finalist in SIH (Smart India Hackathon conducted by MHRD) thousands of teams participate in this.',
      image: require('./assets/images/sihLogo.jfif'),
      footerLink: [
        {
          name: 'Certificate Link',
          url:
            'https://media-exp1.licdn.com/dms/document/C4E2DAQEVv76OF_-Y_A/profile-treasury-document-pdf-analyzed/0/1600155816599?e=1610298000&v=beta&t=9EoHKGEWww_5_jZHXKBJJs-XkDdbNcYRdyU2FVOxWCg',
        },
        {
          name: 'Blog',
          url:
            'https://medium.com/mindmeld/conversational-ai-at-smart-india-hackathon-2020-1793dfa0b574',
        },
        {
          name: 'Demo',
          url:
            'https://www.linkedin.com/posts/thesid01_ciscoabrdevnet-mindmeld-smartindiahackathon-activity-6696085458780258304-o29k',
        },
      ],
    },
    {
      title: 'Managing Team Representative',
      subtitle:
        'Responsible for organizing NSS session such as cleanliness drive, visit old age home, visit nearby villages, etc.',
      image: require('./assets/images/nssLogo.png'),
      footerLink: [
        {
          name: 'Certificate',
          url:
            '',
        },
      ],
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: 'Blogs',
  subtitle:
    'With Love for Developing cool stuff, I love to write and teach others what I have learnt.',

  blogs: [
    {
      url:
        'https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae',
      title: 'Win a Google Assistant Tshirt and $200 in Google Cloud Credits',
      description:
        'Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?',
    },
    {
      url: 'https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e',
      title: 'Why REACT is The Best?',
      description:
        'React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies.',
    },
  ],
  display: false, // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: 'TALKS',
  subtitle: emoji(
    'I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅'
  ),

  talks: [
    {
      title: 'Build Actions For Google Assistant',
      subtitle: 'Codelab at GDG DevFest Karachi 2019',
      slides_url: 'https://bit.ly/saadpasta-slides',
      event_url: 'https://www.facebook.com/events/2339906106275053/',
    },
  ],
  display: false, // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji('Podcast 🎙️'),
  subtitle: 'I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY',

  // Please Provide with Your Podcast embeded Link
  podcast: [
    'https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo',
  ],
  display: false, // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji('Contact Me ☎️'),
  subtitle:
    'Discuss a project or just want to say hi? My Inbox is open for all.',
  number: '+91-8604074906',
  emailAddress: 'sidkv.skv@gmail.com',
};

// Twitter Section

const twitterDetails = {
  userName: '_thesid01', //Replace "twitter" with your twitter username without @
  display: true, // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
};
